import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 1.5rem;
`;